<template>
  <LayoutModalHeaderComponent>
    <template #content>
      <h1 :class="$style.title">{{ page?.title }}</h1>
      <div :class="$style.dateRange">
        <CoreDateTimeRangeComponent
          :dateStart="page?.dateStart"
          :dateEnd="page?.dateEnd"
          format="MMMM YYYY"
        />{{ !page?.dateEnd && page?.dateStart ? ` – ${$t('time.ongoing')}` : null }}
      </div>
    </template>

    <template #information>
      <div
        v-if="page?.archived === true"
        :class="$style.archived"
      >
        <span :class="$style.archivedLabel">{{ $t('shared.archived') }}</span>
      </div>
    </template>

    <template #linkToClose>
      <i18nLink
        :to="{ name: 'projects' }"
      >
        <CoreButtonsCloseComponent />
      </i18nLink>
    </template>
  </LayoutModalHeaderComponent>
</template>

<script lang="ts" setup>
const props = defineProps<{
  page: object
}>()

const route = useRoute()
const query = computed(() => filterRouteQuery(route?.query))
</script>

<style module>
.title {
  composes: reset-heading from global;
  composes: font-size-x-large from global;
}

.dateRange {
  composes: reset-heading from global;
  composes: font-helvetica font-size-small from global;
}

.archived {
  composes: font-size-small font-helvetica from global;

  margin-top: var(--lh);

  grid-column: 1 / -1;
}

.archivedLabel {
  composes: font-size-small font-helvetica label-inverted from global;
}
</style>
